<template>
  <v-container class="pa-4" fluid>
    <v-row class="text-center" no-gutters>
      <v-col cols="12">
        <v-img alt="PARKING.COM" class="my-3" height="42" contain src="../assets/logo_huge_drk.png" />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card class="mx-auto rounded-lg" max-width="374">
          <template slot="progress">
            <v-progress-linear color="red" height="10" indeterminate></v-progress-linear>
          </template>
          <div style="position: relative">
            <v-img class="rounded-t-lg" max-height="150px" style="filter: brightness(50%)" :src="
              bookingDetails.hasOwnProperty('zone') && bookingDetails.zone.image != '' && bookingDetails.zone.image != null
                ? bookingDetails.zone.image
                : zoneImgURL
            " :lazy-src="
  bookingDetails.hasOwnProperty('zone') && bookingDetails.zone.image != '' && bookingDetails.zone.image != null
    ? bookingDetails.zone.image
    : zoneImgURL
" alt="Parking.com garage">
              <template v-slot:placeholder>
                <v-row no-gutters class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <!-- <div class="thankyou_header white--text">THANK YOU!</div> -->
          </div>
          <v-card-title class="pa-1"></v-card-title>
          <v-card-text class="pb-1">
            <v-row no-gutters class="mx-0">
              <v-col class="pa-1">
                <p class="black--text">
                  {{
                    bookingDetails.hasOwnProperty("booking")
                    ? bookingDetails.booking.header
                    : ""
                  }}
                </p>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="" class="align-self-center text-center" v-show="
                bookingDetails.hasOwnProperty('booking') &&
                bookingDetails.booking.hasOwnProperty('TypeOfBooking') &&
                bookingDetails.booking.TypeOfBooking == 'Monthly'
              ">
                <v-btn class="elevation-0 white--text" tile x-small color="green darken-2">Monthly</v-btn>
              </v-col>
              <v-col cols="" class="align-self-center text-center" v-show="
                bookingDetails.hasOwnProperty('booking') &&
                bookingDetails.booking.hasOwnProperty('TypeOfBooking') &&
                bookingDetails.booking.TypeOfBooking == 'Employee'
              ">
                <v-btn class="elevation-0 white--text" tile x-small color="green darken-2">Employee</v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-1 mx-0"
              v-if="bookingDetails.hasOwnProperty('booking') && bookingDetails.hasOwnProperty('zone') && bookingDetails.booking.vehicleNo != null && bookingDetails.booking.vehicleNo != '' && bookingDetails.zone.isGated == '0'">
              <v-col cols="4" class="text-left pa-1">
                <p class="booking_date_header mb-0">License Plate:</p>
              </v-col>
              <v-col class="text-right pa-1">
                <p class="booking_date mb-0">
                  {{ bookingDetails.hasOwnProperty("booking") ? bookingDetails.booking.vehicleNo : "" }}
                </p>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-1 mx-0">
              <v-col cols="4" class="text-left pa-1">
                <p class="booking_date_header mb-0">Entered At:</p>
              </v-col>
              <v-col class="text-right pa-1">
                <p class="booking_date mb-0">
                  {{
                    bookingDetails.hasOwnProperty("booking") &&
                    bookingDetails.booking.hasOwnProperty("entrytime")
                    ? formatDateTime(bookingDetails.booking.entrytime)
                    : ""
                  }}
                </p>
              </v-col>
            </v-row>
            <v-row no-gutters class="mx-0">
              <v-col cols="4" class="text-left pa-1">
                <p class="booking_date_header">Exited At:</p>
              </v-col>
              <v-col class="text-right pa-1">
                <p class="booking_date">
                  {{
                    bookingDetails.hasOwnProperty("booking") &&
                    bookingDetails.booking.hasOwnProperty("exittime")
                    ? formatDateTime(bookingDetails.booking.exittime)
                    : ""
                  }}
                </p>
              </v-col>
            </v-row>
            <v-row no-gutters class="mx-0">
              <v-col cols="12" class="mt-4 text-center color-black" style="font-size: 12px">
                <p>
                  A credit card was not added prior to exit. Vehicle is in violation and may be cited.
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import APIHelper from "../apiHelper";
import { EventBus } from "@/lib/EventBus";
// import axios from "axios";
// import loggerHelper from "../loggerHelper";
import { mapGetters } from "vuex";
export default {
  name: "UnpaidExit",
  data: () => ({
    pageHeight: window.outerHeight,
  }),
  computed: {
    ...mapGetters({
      bookingId: "getterBookingId",
      bookingDetails: "getterBookingDetails",
    }),
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      vm.$vuetify.goTo(0);
      if (vm.bookingId != null) {
        try {
          var bookingDetails = await APIHelper(
            "GET",
            "/api/v1/booking/config/" + vm.bookingId
          );
          vm.$store.commit(
            "SET_BOOKING_DETAILS",
            bookingDetails.data?.data ? bookingDetails.data.data : null
          );
        } catch (error) {
          console.log(error);
        }
      }
    });
  },
  mounted() { },
  methods: {
    navigateToReceipt() {
      this.$router.push({ path: "/receipt" });
    },
    formatDateTime(time) {
      let utcDate = new Date(time * 1000).toUTCString(); //"Wed, 27 Jan 2021 13:59:04 GMT"
      let month = utcDate.split(",")[1].split(" ")[2]; // Jan
      let date = utcDate.split(",")[1].split(" ")[1]; // 27
      let hr = utcDate.split(",")[1].split(" ")[4].split(":")[0]; // 13
      let min = utcDate.split(",")[1].split(" ")[4].split(":")[1]; //59
      let formatHr = Number(hr) > 12 ? Number(hr) - 12 : Number(hr); // 1
      formatHr = Number(formatHr) >= 10 ? Number(formatHr) : "0" + formatHr; //01
      let amOrpm = Number(hr) >= 12 ? "PM" : "AM"; //PM
      return month + " " + date + ", " + formatHr + ":" + min + " " + amOrpm; //Jan 27, 01:59 PM
    },
    checkReservationEndDate() {
      return this.bookingDetails?.booking?.revEnd &&
        new Date(
          (Number(this.bookingDetails.booking.revEnd) -
            Number(this.bookingDetails.zone.timezoneoffset) - Number(this.bookingDetails.zone.timezonedstoffset)) *
          1000
        ).getTime() -
        new Date().getTime() >
        0
        ? true
        : false;
    },
    async reEnter() {
      if (this.bookingId != null) {
        try {
          var bDetails = await APIHelper(
            "GET",
            "/api/v1/booking/config/" + this.bookingId + "?reEnter=1"
          );
          this.$store.commit(
            "SET_BOOKING_DETAILS",
            bDetails.data?.data ? bDetails.data.data : null
          );
          let bookingState = bDetails.data?.data?.booking?.state
            ? bDetails.data.data.booking.state
            : null;
          if (bookingState == 8 || bookingState == 10 || bookingState == 11) {
            await this.$router.replace({ path: "/checkout" });
            if(this.bookingDetails?.booking?.autoP2PDetails)
             {
              EventBus.$emit('AUTO_P2P_BID', this.bookingDetails)
             }
            EventBus.$emit('SET_FREE_BOOKING')
          } else if (bookingState == 2) {
            await this.$router.replace({ path: "/checkedin" });
            EventBus.$emit('GET_FREE_BOOKING')
          } else if (bookingState == 0) {
            this.$router.replace({ path: "/checkin" });
          } else {
            setTimeout(async () => {
              await this.getBookingState();
            }, 4000);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    navigateToParkingSignUpPage() {
      // var self = this;
      let env = this.bookingDetails?.booking?.env_overRide;
      let url = "";
      switch (env) {
        case "qa":
          url = "https://guest:guest-test@qa.parking.com/sign-up";
          break;
        case "uat":
          url = "https://uat.parking.com/sign-up";
          break;
        case "prod":
          url = "https://parking.com/sign-up";
          break;
      }
      let email = this.bookingDetails?.user?.email;
      let contact = this.bookingDetails?.user?.contact;
      contact = contact.length > 10 ? contact.substring(contact.length - 10) : contact;
      let createAccUrl = url + '?email=' + email + '&phone=' + contact + '&orderId=' + this.bookingDetails?.booking?.orderID
      window.open(createAccUrl, "_blank", "", true);
    },
    // closeWindow(){
    //   // window.open(window.location, '_self').close();
    //   window.close();
    // }
  },
};
</script>
<style lang="less">
.receipt_btn {
  background-color: #f2555c !important;
  width: 100%;
  font-size: 18px !important;
  font-weight: 700 !important;
  height: 50px !important;
  letter-spacing: normal !important;
}

.thankyou_header {
  position: absolute;
  bottom: 20px;
  left: 16px;
  font-size: 24px;
  font-weight: bolder;
}

.booking_date {
  font-weight: normal;
  font-size: 13px;
  color: #3d3f3c !important;
}

.booking_date_header {
  color: #3d3f3c !important;
  font-weight: bold;
  font-size: 14px;
}

.total-parking {
  color: #3d3f3c;
  font-size: 0.875rem !important;
  font-weight: 500;
  line-height: 2.25rem;
  letter-spacing: 0.0892857143em !important;
  text-transform: uppercase !important;
}

.amount-text {
  color: #3d3f3c;
  font-size: 34px;
}

.amount-content-position {
  position: relative;
}

.validate-image {
  position: absolute !important;
  right: 0;
  bottom: 20px;
}
</style>
